<script setup lang="ts">
import { Frequency, frequencyDisplayName } from '@/enums';
import { PropType } from 'vue';

defineProps({
    frequency: {
        type: Number as PropType<Frequency | null>,
        required: true
    }
});  
</script>

<template>
    <section class="frequencies-container">
        <p v-if="frequency !== null && frequency !== Frequency.OneTime" class="rd-w-full frequency-text">
            This will create a recurring schedule, charged
            <strong class="rd-lowercase">
                {{ frequencyDisplayName(frequency) }}
            </strong>.
        </p>
        <p v-else class="frequency-text">
            This will be processed as a <strong class="rd-lowercase">one time</strong> gift.
        </p>
    </section>
</template>